import { render, staticRenderFns } from "./ManualFirmOrder.vue?vue&type=template&id=01488935&scoped=true"
import script from "./ManualFirmOrder.vue?vue&type=script&lang=js"
export * from "./ManualFirmOrder.vue?vue&type=script&lang=js"
import style0 from "./ManualFirmOrder.vue?vue&type=style&index=0&id=01488935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01488935",
  null
  
)

export default component.exports